<template>
  <div class="container capacity-dashboard">
    <div v-if="loading" class="dashboard-status" role="status">正在获取报表…</div>
    <div v-else-if="error" class="dashboard-status" role="alert">
      <el-alert :title="error" type="error" :closable="false" show-icon />
      <el-button @click="loadReport">重试</el-button>
    </div>
    <div v-else class="dashboard-content">
      <iframe v-for="embed in embeds" :key="embed.url" :src="embed.url" :title="embed.title"
        class="dashboard-frame" referrerpolicy="no-referrer" />
    </div>
  </div>
</template>

<script>
import { capacity_dashboard } from '@/api/getData';
import bus from '@/components/common/bus';

const REPORTS = ['overview', 'team', 'subject'];

export default {
  name: 'CapacityDashboard',
  data: () => ({ report: 'overview', loadedReport: '', embeds: [], loading: false, error: '', requestId: 0, active: true }),
  created() {
    this.report = REPORTS.includes(this.$route.query.report) ? this.$route.query.report : 'overview';
    bus.$on('logout', this.stopReport);
    this.loadReport();
  },
  activated() {
    const wasActive = this.active;
    this.active = true;
    this.report = REPORTS.includes(this.$route.query.report) ? this.$route.query.report : 'overview';
    if (!wasActive && this.loadedReport !== this.report) this.loadReport();
  },
  deactivated() { this.pauseReport(); },
  beforeRouteLeave(to, from, next) { this.pauseReport(); next(); },
  beforeDestroy() { this.stopReport(); bus.$off('logout', this.stopReport); },
  watch: {
    '$route.query.report'(value) {
      const report = REPORTS.includes(value) ? value : 'overview';
      if (report !== this.report) { this.report = report; if (this.active) this.loadReport(); }
    }
  },
  methods: {
    pauseReport() { this.active = false; this.requestId += 1; this.loading = false; },
    stopReport() { this.pauseReport(); this.loadedReport = ''; this.embeds = []; },
    async loadReport() {
      if (!this.active) return;
      const token = localStorage.getItem('token');
      const id = ++this.requestId;
      this.loadedReport = ''; this.embeds = []; this.error = ''; this.loading = true;
      if (!token) { this.error = '请先登录后查看报表'; this.loading = false; return; }
      try {
        const result = await capacity_dashboard(this.report);
        if (!this.active || id !== this.requestId || token !== localStorage.getItem('token')) return;
        if (!result || result.code !== 200000 || !result.data || result.data.report !== this.report ||
            !Array.isArray(result.data.embeds) || !result.data.embeds.length) throw new Error('invalid_report');
        const valid = result.data.embeds.every(embed => {
          if (!embed || typeof embed.title !== 'string' || typeof embed.url !== 'string') return false;
          const url = new URL(embed.url);
          return url.protocol === 'https:' && url.hostname === 'bi.aliyun.com' && !url.username && !url.password;
        });
        if (!valid) throw new Error('invalid_report');
        this.embeds = result.data.embeds;
        this.loadedReport = this.report;
      } catch (error) {
        if (!this.active || id !== this.requestId || token !== localStorage.getItem('token')) return;
        const status = error.response && error.response.status;
        this.error = status === 503 ? '报表尚未配置完成，请联系管理员' :
          status === 401 || status === 403 ? '登录已失效，请重新登录' : '报表加载失败，请重试';
      } finally {
        if (id === this.requestId) this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.capacity-dashboard { display: flex; flex-direction: column; height: 100%; padding: 12px; box-sizing: border-box; overflow: hidden; }
.dashboard-content { flex: 1; min-height: 0; }
.dashboard-frame { display: block; width: 100%; height: 100%; border: 0; }
.dashboard-status { padding: 12px 0; }
.dashboard-status .el-button { margin-top: 8px; }
</style>
